export default [
    {
        path: '/contact',
        name: 'contact',
        meta: {
            access: ['AUTH_CUSTOMER'],
            title: 'contact',
            icon: 'icon-Group-1',
            notPageView: true,
        },
        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/Layout.vue'),
        // redirect: { name: 'contact_list_all_user' },
        children: [
            {
                // 注：这里多家一层 /index 是防止 /contact 直接访问到 contact_list_all_user
                path: '/contact/index',
                name: 'contact_list',
                meta: {
                    access: ['CONTACT_LIST'],
                    title: 'contact',
                    icon: 'icon-Group-1',
                },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/index.vue'),
                redirect: { name: 'contact_list_all_user' },
                children: [
                    {
                        path: '/contact/all',
                        name: 'contact_list_all_user',
                        meta: {
                            hideInMenu: true,
                            access: ['CONTACT_LIST'],
                            title: 'contact_list_all_user',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/AllList.vue'),
                    },
                    /** todo 废弃 待移除 start */
                    {
                        path: '/contact/valid',
                        name: 'contact_list_valid_user',
                        meta: {
                            hideInMenu: true,
                            access: ['CONTACT_LIST'],
                            title: 'contact_list_valid_user',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/ValidList.vue'),
                        redirect: { name: 'contact_list_all_user' },
                    },
                    {
                        path: '/contact/my',
                        name: 'contact_list_my_user',
                        meta: {
                            hideInMenu: true,
                            access: ['CONTACT_LIST'],
                            title: 'contact_list_my_user',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/MyList.vue'),
                        redirect: { name: 'contact_list_all_user' },
                    },
                    /** todo 废弃 待移除 end */
                    {
                        path: 'list',
                        name: 'contact_list_all_user',
                        meta: {
                            hideInMenu: true,
                            access: ['CONTACT_LIST'],
                            title: 'contact_all_user',
                            icon: 'icon-Group-1',
                        },
                        redirect: { name: 'contact_list_all_user' },
                    },
                ],
            },
            {
                path: 'import',
                name: 'contact_list_import',
                meta: {
                    hideInMenu: true,
                    access: ['CONTACT_LIST'],
                    title: 'contact_list_import',
                    icon: 'icon-Group-1',
                },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/Import/index.vue'),
            },
            {
                path: 'chat_management',
                name: 'contact_chat_management',
                meta: {
                    access: ['AUTH_CHAT_MANAGEMENT'],
                    title: 'contact_chat_management',
                    icon: 'icon-Group-1',
                    notPageView: true,
                },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/ChatManagement/index.vue'),
                // redirect: { name: 'contact_chat_management_session_list' },
                children: [
                    {
                        path: 'session_list',
                        name: 'contact_chat_management_session_list',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_CHAT_MANAGEMENT_ASSIGNED', 'AUTH_CHAT_MANAGEMENT_UNDISTRIBUTED_ROBOT'],
                            title: 'contact_chat_management',
                            icon: 'icon-fenxi',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/ChatManagement/SessionList.vue'),
                    },
                    {
                        path: 'search_chat_content',
                        name: 'contact_chat_management_search_chat_content',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SESSION_SEARCH'],
                            title: 'contact_chat_management',
                            icon: 'icon-fenxi',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/ChatManagement/SearchChatContent.vue'),
                    },
                ],
            },
            {
                path: 'form_management',
                name: 'contact_form_management',
                meta: {
                    access: ['AUTH_ORDER'],
                    title: 'contact_form_management',
                    icon: 'icon-Group-1',
                    notPageView: true,
                },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/FormManagement/index.vue'),
                // redirect: { name: 'contact_form_management_order_list' },
                children: [
                    {
                        path: 'order_list',
                        name: 'contact_form_management_order_list',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_ORDER'],
                            title: 'contact_form_management',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */'@/views/main/contact/FormManagement/Order/index.vue'),
                    },
                    {
                        path: 'reviews_list',
                        name: 'contact_form_management_reviews_list',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_ORDER'],
                            title: 'contact_form_management',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */'@/views/main/contact/FormManagement/Reviews/index.vue'),
                    },
                    {
                        path: 'product_list',
                        name: 'contact_form_management_product_list',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_ORDER'],
                            title: 'contact_form_management',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */'@/views/main/contact/FormManagement/Product/index.vue'),
                    },
                ],
            },
            {
                path: 'form_management/order_setting',
                name: 'contact_form_management_order_setting',
                meta: {
                    hideInMenu: true,
                    access: ['AUTH_ORDER'],
                    title: 'contact_form_management',
                    icon: 'icon-Group-1',
                },
                component: () => import(/* webpackChunkName: "contact" */'@/views/main/contact/FormManagement/Order/setting.vue'),
            },
            {
                path: 'contact_tags',
                name: 'contact_tags',
                meta: {
                    access: ['AUTH_TAG_MANAGEMENT'],
                    title: 'contact_tags',
                    icon: 'icon-Group-1',
                    notPageView: true,
                },
                // redirect: { name: 'contact_tags_management' },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/TagsManagement/index.vue'),
                children: [
                    {
                        path: 'visitor_tags',
                        name: 'contact_tags_management',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_GUEST_TAG'],
                            title: 'contact_tags',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/TagsManagement/VisitorTags/index.vue'),
                    },
                    {
                        path: 'session_tags',
                        name: 'contact_tags_session',
                        meta: {
                            hideInMenu: true,
                            access: ['AUTH_SETTING_SESSION_TAG'],
                            title: 'contact_tags',
                            icon: 'icon-Group-1',
                        },
                        component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/TagsManagement/SessionTags/index.vue'),
                    },
                ],
            },
            {
                path: 'verbal_trick',
                name: 'contact_verbal_trick',
                meta: {
                    // access: ['AUTH_SCRIPT_LIBRARY'],
                    title: 'contact_verbal_trick',
                    icon: 'icon-Group-1',
                },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/VerbalTrick/index.vue'),
            },
            {
                path: 'material_list',
                name: 'contact_material_list',
                meta: {
                    access: ['AUTH_MATERIAL'],
                    title: 'contact_material_list',
                    icon: 'icon-Group-1',
                },
                component: () => import(/* webpackChunkName: "contact" */ '@/views/main/contact/Material/index.vue'),
            },
        ],
    },
];
